import { graphql } from 'react-relay';

export const ProfileRootQuery = graphql`
    query ProfileRootQuery(
        $firmUrlLabel: String!
        $shouldRenderOverview: Boolean!
        $shouldRenderProjects: Boolean!
        $isEditMode: Boolean!
    ) {
        viewer {
            ...DesignProfileWrapper_viewer
        }
    }
`;
